import React from 'react';

const R = 30;
const CIRC = 2 * Math.PI * R;

export const WalletGauge = ({ pct = 0, altPct = 0, metric = 'val', size = 76 }) => {
  const color = pct >= 99 ? '#8FD694' : pct < 10 ? '#FF6B52' : '#F2B14C';
  const offset = CIRC * (1 - pct / 100);

  return (
    <div className="flex flex-col items-center shrink-0" data-testid="wallet-gauge">
      <svg viewBox="0 0 76 76" width={size} height={size}>
        <circle cx="38" cy="38" r={R} fill="none" stroke="var(--dash-panel2)" strokeWidth={8} />
        <circle
          cx="38" cy="38" r={R} fill="none"
          stroke={color} strokeWidth={8} strokeLinecap="round"
          strokeDasharray={CIRC} strokeDashoffset={offset}
          transform="rotate(-90 38 38)"
          style={{ transition: 'stroke-dashoffset 0.5s ease' }}
        />
        <text x="38" y="36" textAnchor="middle" fontFamily="Hanken Grotesk" fontWeight="700" fontSize={pct < 1 ? '14' : '17'} fill="var(--dash-ink)">
          {pct}%
        </text>
        <text x="38" y="49" textAnchor="middle" fontFamily="JetBrains Mono" fontSize="7" fill="var(--dash-mut)">
          {metric === 'val' ? 'BY $' : 'BY t'}
        </text>
      </svg>
      <div className="text-[9.5px] font-mono text-dash-mut mt-1">
        {altPct}% by {metric === 'val' ? 'volume' : 'value'}
      </div>
    </div>
  );
};
